import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';

import { SubPageLayout } from '../sub-page-layout';
import { EntityCreateContainer } from '../components/entity-create.container';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export const EntityCreate: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Entity - Create</title>
      </Helmet>
      <SubPageLayout
        header={
          <PageHeader title={<Typography.Title style={{ fontSize: '30px', marginTop: '12px' }}>Create Entity</Typography.Title>} onBack={() => navigate(-1)}></PageHeader>
        }
      >
        <EntityCreateContainer />
      </SubPageLayout>
    </>
  );
};
